import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Textfield } from "@similarweb/ui-components";

export const StyledTextfield = styled(Textfield)<{
    isFocused?: boolean;
    disabled?: boolean;
    margin?: string;
    width: number;
}>`
    width: ${({ width = 244 }) => `${width}px`};
    margin: ${({ margin }) => margin};

    & .input-container {
        border-color: ${({ isFocused }) => (isFocused ? colorsPalettes.blue[400] : colorsPalettes.midnight[50])};
        ${({ disabled }) =>
            disabled &&
            css`
                color: ${colorsPalettes.midnight[100]};
                background-color: ${colorsPalettes.bluegrey[200]};
            `}
    }
    & input {
        ${({ disabled }) =>
            disabled &&
            css`
                color: ${colorsPalettes.midnight[100]};
                background-color: ${colorsPalettes.bluegrey[200]};
                &::placeholder {
                    color: ${colorsPalettes.midnight[100]};
                }
            `}
    }
`;
